import { closeRealtimeChannel } from "../../../helpers/closeRealtimeChannel";
import { type AppThunk } from "../../../index";
import { unsubscribeFromUserDetails as unsubscribeAction } from "../reducer";
import { claimRealtimeSlot } from "../../../helpers/realtimeSlot";

export const unsubscribeFromUserProfile =
  (): AppThunk =>
  async (dispatch, _, { subscriptions, db }) => {
    // take the slot so a subscribe still waiting on its fetch does not resurrect the channel
    claimRealtimeSlot(subscriptions, "userProfile");

    dispatch(unsubscribeAction());

    // detach synchronously - awaiting the close first would let a subscribe that
    // already claimed the slot store its channel, only for this thunk to null it out
    const channel = subscriptions.realtimeUserDetailsChannel;
    subscriptions.realtimeUserDetailsChannel = null;
    subscriptions.userDetailsChannelName = null;
    void closeRealtimeChannel(db, channel);
  };
